import { BlockOptions } from "../context/types";

export const getHasBlockOptions = (blockOptions: BlockOptions): boolean => {
  const { start = [], end = [] } = blockOptions || {};

  return start.length > 0 && end.length > 0;
};
